module.exports = __webpack_public_path__ + "img/anquan1-1.2a9cb097.jpg";